import axios from 'axios';

interface GetPreSignedURLParams {
  fileType: string;
  fileName: string;
}

export const getPreSignedURLAPI = ({
  fileType,
  fileName,
}: GetPreSignedURLParams): any =>
  axios.post(`${process.env.REACT_APP_INSTANCE}/api/upload/preSignedURL`, {
    fileType,
    fileName,
  });

// Upload Image
export const uploadToS3 = async (url: string, file: any) =>
  axios.put(url, file, {
    headers: {
      ContentType: file.type,
    },
  });
